module.exports = __webpack_public_path__ + "static/media/IMG_6214 - Copy 2 (1).841ab7c5.jpg";